import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  toggle(event) {
    const row = event.currentTarget
    const nodeId = row.dataset.nodeId
    if (!nodeId) return

    if (event.type === 'keydown') event.preventDefault()

    const isCollapsed = row.dataset.collapsed === 'true'

    if (isCollapsed) {
      this.expandNode(row, nodeId)
    } else {
      this.collapseNode(row, nodeId)
    }
  }

  expandNode(row, nodeId) {
    row.dataset.collapsed = 'false'
    row.setAttribute('aria-expanded', 'true')
    this.rotateIcon(row, false)

    // Show direct children only (not recursively — collapsed children stay hidden)
    this.directChildren(nodeId).forEach(child => {
      child.classList.remove('d-none')
    })
  }

  collapseNode(row, nodeId) {
    row.dataset.collapsed = 'true'
    row.setAttribute('aria-expanded', 'false')
    this.rotateIcon(row, true)

    // Hide all descendants recursively
    this.allDescendants(nodeId).forEach(child => {
      child.classList.add('d-none')
      // Also mark expanded children as collapsed so re-expand shows correctly
      if (child.dataset.nodeId) {
        child.dataset.collapsed = 'true'
        child.setAttribute('aria-expanded', 'false')
        this.rotateIcon(child, true)
      }
    })
  }

  directChildren(parentId) {
    return Array.from(this.element.querySelectorAll(`tr[data-parent-id="${parentId}"]`))
  }

  allDescendants(parentId) {
    const descendants = []
    const directChildren = this.directChildren(parentId)

    directChildren.forEach(child => {
      descendants.push(child)
      if (child.dataset.nodeId) {
        descendants.push(...this.allDescendants(child.dataset.nodeId))
      }
    })

    return descendants
  }

  rotateIcon(row, collapsed) {
    const icon = row.querySelector('[data-review-tree-icon]')
    if (icon) {
      icon.classList.toggle('bulk-edit-review-tree__icon--collapsed', collapsed)
    }
  }
}
